// Single source of truth for node-type terminology.
//
// Projectly's Pipeline view and Operations view render the SAME node graph —
// the only difference is terminology (technical vs business-friendly), so a
// non-technical user sees "Department / Approval / Records" where a builder
// sees "Function / Gate / Collection". Both maps MUST cover exactly the same
// node types, or one view will fall back to the raw internal id (e.g.
// "functionNode") and the mirror breaks. A guard test enforces that here.

export const PIPELINE_LABELS = {
  functionNode:   'Function',
  humanNode:      'Human',
  gateNode:       'Gate',
  connectionNode: 'Connection',
  noteNode:       'Note',
  collectionNode: 'Collection',
  triggerNode:    'Trigger',
  conditionNode:  'Condition',
  actionNode:     'Action',
};

export const OPERATIONS_LABELS = {
  functionNode:   'Department',
  humanNode:      'Stakeholder',
  gateNode:       'Approval',
  connectionNode: 'App',
  noteNode:       'Memo',
  collectionNode: 'Records',
  triggerNode:    'Automation Start',
  conditionNode:  'Decision',
  actionNode:     'Auto Step',
};

// Convenience: the label for a node type in the active view.
export function nodeTypeLabel(nodeType, opsMode) {
  return (opsMode ? OPERATIONS_LABELS : PIPELINE_LABELS)[nodeType] || nodeType;
}
